import React from 'react'
import styles from './Modals.module.scss'

// Modals
import JointAccountHolderInfoModal from './JointAccountHolderInfoModal/JointAccountHolderInfoModal'
import SuccessorCustodianInfoModal from './SuccessorCustodianInfoModal/SuccessorCustodianInfoModal'
import BeneficiaryInfoModal from './BeneficiaryInfoModal/BeneficiaryInfoModal'
import TrusteeInfoModal from './TrusteeInfoModal/TrusteeInfoModal'
import PaperlessInfoModal from './PaperlessInfoModal/PaperlessInfoModal'
import GrantorInfoModal from './GrantorInfoModal/GrantorInfoModal'
import ContingentBeneficiaryModal  from './ContingentBeneficiaryModal/ContingentBeneficiaryModal'

const PWMModals = props => (
  <div className={styles.modal__group}>
    <JointAccountHolderInfoModal />
    <SuccessorCustodianInfoModal />
    <BeneficiaryInfoModal />
    <TrusteeInfoModal />
    <PaperlessInfoModal />
    <GrantorInfoModal />
    <ContingentBeneficiaryModal />
  </div>
)

export default PWMModals



// WEBPACK FOOTER //
// ./src/components/Onboarding/Modals/Modals.jsx